export function setItemToStore(item, value) {
  try {
    localStorage.setItem(item, value);
    return true;
  } catch (error) {
    // Swallow quota / access errors (e.g. QuotaExceededError, Safari private mode)
    // so a failed write never crashes the app.
    console.warn(`Failed to write "${item}" to localStorage:`, error);
    return false;
  }
}

export function itemExistInStore(item) {
  const exist = localStorage.getItem(item);
  return exist ? true : false;
}

export function getItemFromStore(item) {
  return localStorage.getItem(item);
}

export function removeItemFromStore(item) {
  localStorage.removeItem(item);
}

export function setItemToSessionStore(item, value) {
  try {
    sessionStorage.setItem(item, value);
    return true;
  } catch (error) {
    // QuotaExceededError (or access denied) must not crash the app. Drop a stale
    // copy so a later, smaller write can still succeed, then report failure.
    console.warn(`Failed to write "${item}" to sessionStorage:`, error);
    try {
      sessionStorage.removeItem(item);
    } catch (_) {
      /* ignore */
    }
    return false;
  }
}

export function itemExistInSessionStore(item) {
  const exist = sessionStorage.getItem(item);
  return exist ? true : false;
}

export function getItemFromSessionStore(item) {
  return sessionStorage.getItem(item);
}

export function removeItemFromSessionStore(item) {
  sessionStorage.removeItem(item);
}

export function setCookie(name, value) {
  const expiryDate = new Date();
  expiryDate.setDate(expiryDate.getDate() + 1);
  const expires = expiryDate.toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/`;
}

export function getCookie(name) {
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith(name + "=")) {
      return cookie.substring(name.length + 1);
    }
  }
  return null;
}
